import { Button } from '@sunwebgroup/uds-ui/button'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import { identity } from 'ramda'
import { useIntl } from '@/intl'
import { BusInfo, RouteDate } from '@/scopes/prices/domain/transports/types'
import styles from './BusCard.module.css'

interface BusCardProps extends BusInfo {
  date?: RouteDate
  cityName: string
  id: string
  isSelected: boolean
  setSelected?: ((val: string) => void) | undefined
  noActiveState?: boolean | undefined
  stationName: string
}

export function BusCard({
  id,
  cityName,
  date,
  averagePrice,
  isSelected,
  setSelected = identity,
  noActiveState,
  stationName,
}: BusCardProps) {
  const intl = useIntl()
  const isClickable = !isSelected && !noActiveState
  const selectCard = () => isClickable && setSelected(id)

  return (
    <div
      className={cn(styles.listItemRoot, isSelected && !noActiveState && styles.listItemRootSelected)}
      onClick={selectCard}
      role="presentation"
    >
      <div className={styles.cardContent}>
        <div className={styles.listItemContent}>
          <Typography variant="body-l-bold-tight">{cityName}</Typography>
          {date?.time
            ? (
                <Typography variant="body-m-regular-tight">{date.time}</Typography>
              )
            : (
                <Typography variant="body-m-regular-tight">&nbsp;</Typography>
              )}
          <div className={styles.featuresWrapper}>
            <div className={styles.infoBlock}>
              <div className={styles.infoItem}>
                <Icon className={styles.icon} glyph="BusFront" size={18} />
                <Typography variant="body-s-regular-tight">{stationName}</Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={cn(styles.priceWrapper, isSelected && !noActiveState && styles.priceWrapperSelected)}>
        <div>
          <Typography variant="body-m-bold-tight">{intl.formatCurrency(averagePrice, { showSign: true })}</Typography>
          <Typography variant="body-m-bold-tight">
            {' '}
            {intl.formatMessage({ id: 'prices_transport_selector_price-per-person_abbreviation' })}
          </Typography>
        </div>
        {!isSelected && (
          <Button size="S" variant="secondary">
            {intl.formatMessage({
              id: 'prices_transport_selector_bus-selector-select',
            })}
          </Button>
        )}
      </div>
    </div>
  )
}
